import SlideUpDown from "Components/slideUpDown";
import classNames from "classnames";
import includes from "lodash/includes";
import styled, { css } from "styled-components";
import { NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME, NAV_ITEM_ACTION_PANEL_CLASS_NAME, NAV_ITEM_CLASS_NAME } from "../constants";
export const SIZES = {
    MIN_ACTION_ELEMENT_SIZE: 26,
    IMG_SIZE: 16,
    SUB_ITEMS_GAP: 3
};
const MARGINS = {
    right: "-0.5em -0.25em -0.5em 0",
    left: "-0.5em 0.4em -0.5em -0.4em"
};
const menuItemStyle = (gridCols) => css `
  display: grid;
  align-items: center;
  grid-template-columns: ${gridCols};
`;
export const menuActionStyle = (size, color = "gray-300") => css `
  min-width: ${size}px;
  min-height: ${size}px;
  > .dx-button {
    min-width: ${size}px !important;
    min-height: ${size}px !important;
    width: ${size}px !important;
    height: ${size}px !important;
  }
  height: auto;
  border-radius: ${({ theme }) => theme["border-radius-medium"]};
  color: ${({ theme }) => theme[color]};
  cursor: pointer;
  &:hover {
    background-color: rgba(256, 256, 256, 0.08);
  }
`;
export default {
    MenuLink: styled.a.withConfig({
        shouldForwardProp: (prop) => !includes(["gridCols"], prop)
    }) `
    ${({ gridCols }) => menuItemStyle(gridCols)}
  `,
    MenuBlock: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["gridCols"], prop)
    }) `
    ${({ gridCols }) => menuItemStyle(gridCols)}
  `,
    SlideUpDown: styled(SlideUpDown) `
    background-color: transparent;
    .${NAV_ITEM_CLASS_NAME} {
      margin-top: ${SIZES.SUB_ITEMS_GAP}px;
    }
  `,
    MenuLinkActionsPanel: styled.div
        .withConfig({
        shouldForwardProp: (prop) => !includes(["actionIconColor", "position"], prop)
    })
        .attrs({
        className: classNames(NAV_ITEM_ACTION_PANEL_CLASS_NAME, "grid-cols-auto no-gap line-height-1")
    }) `
    color: ${({ theme, actionIconColor }) => theme[actionIconColor || "gray-300"]};
    margin: ${({ position }) => position && MARGINS[position]};
    min-height: ${SIZES.MIN_ACTION_ELEMENT_SIZE}px;
    > *:not(.${NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME}) {
      ${({ actionIconColor }) => menuActionStyle(SIZES.MIN_ACTION_ELEMENT_SIZE, actionIconColor)}
    }
  `,
    TrashIcon: styled.i.attrs({
        className: "icon-trash-filled text-red font-smallest flex-box-centered-content"
    }) `
    ${menuActionStyle(SIZES.MIN_ACTION_ELEMENT_SIZE - 2)}
  `
};
